import {Store} from '../classes/store';
import {ProjectSubmodule} from '../../../resources/submodule/project-submodule.interface';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ProjectSubmoduleStore extends Store<ProjectSubmodule> {

  /** Constructor. */
  constructor(
    private api: ApiLegacyService
  ) {
    super();
  }

  update(updateItem) {

    // Update the store and get the full item
    // const fullItem = super.update(updateItem);
    const selectedItem = super.queryOne(updateItem._id);

    Object.assign(selectedItem, updateItem);

    this.setState(this.state);
    // Return the full newly updated object

    // Add needed data
    updateItem.projectId = selectedItem.projectId;
    updateItem.versionId = selectedItem.versionId;
    updateItem.moduleId = selectedItem.moduleId;

    // Pass the new data to the API
    this.api.updateSubModuleNoLoader(updateItem);

    return selectedItem;
  }


  delete(deleteId) {
    // Update the store and get the full item
    const fullItem = super.delete(deleteId);

    // Pass the new data to the API
    this.api.deactivateSubmodule(fullItem);

    // Deleting a submodule also results in deleting all elements in a submodule
    return fullItem;
  }

  insert(submodule) {
    return this.api.createSubmodule(submodule).pipe(map((insertedSubmodule: ProjectSubmodule) => {
      super.insert(insertedSubmodule);
      return insertedSubmodule;
    }));
  }

}
